import React from 'react';
import { List, Box, Grid } from '@mui/material';
import EventCard from './EventCard';

const EventList = ({ events = [], handleRegister }) => {
  return (
    <List>
      <Grid container spacing={2}>
        {Array.isArray(events) && events.map((event) => (
          <Grid item md={4} key={event.id}>
            <EventCard event={event} handleRegister={handleRegister} />
          </Grid>
        ))}
      </Grid>
      {(!events || events.length === 0) && (
        <Box textAlign='center'>No hay eventos disponibles</Box>
      )}
    </List>
  );
};

export default EventList;